import { render } from "./ObservacoesPedidoEmAndamentoPDF.vue?vue&type=template&id=2550a27a&scoped=true"
import script from "./ObservacoesPedidoEmAndamentoPDF.vue?vue&type=script&lang=js"
export * from "./ObservacoesPedidoEmAndamentoPDF.vue?vue&type=script&lang=js"

import "./ObservacoesPedidoEmAndamentoPDF.vue?vue&type=style&index=0&id=2550a27a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2550a27a"]])

export default __exports__